"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TabScreen = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const core_1 = require("@material-ui/core");
const React = require("react");
const stack_1 = require("../stack");
const TabScreen = ({ tabs }) => {
    const [activeTabIdx, setActiveTabIdx] = React.useState(0);
    if (!tabs.length)
        return null;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(stack_1.Stack, Object.assign({ style: { overflow: 'hidden', gap: 15, marginTop: 8, marginBottom: 30, padding: '16px 4px' }, wrap: true }, { children: tabs.map((tab, idx) => {
                    const onSelect = () => setActiveTabIdx(idx);
                    return (0, jsx_runtime_1.jsx)(TabChip, { title: tab.title, index: idx, isActive: idx === activeTabIdx, onSelect: onSelect }, `tab_chip_${idx}`);
                }) })), tabs[activeTabIdx].component] }));
};
exports.TabScreen = TabScreen;
const TabChip = ({ title, index, isActive, onSelect }) => {
    const color = React.useMemo(() => (isActive ? 'primary' : 'default'), [isActive]);
    return (0, jsx_runtime_1.jsx)(core_1.Chip, { label: title, onClick: onSelect, color: color }, `${index}_chip`);
};
//# sourceMappingURL=index.js.map